// import { GeofencingZone } from '@cube/lib-gis-editor/geofencing/api/api.helper';
import { NgxLoggerLevel } from 'ngx-logger';
import {EnvironmentConfiguration} from '../app/models/environment-configuration';

export const PROFILE_NOT_VALID = new Error('PROFILE NOT VALID');
export let TENANT_CONFIG: EnvironmentConfiguration = {
  settings: {
    routes: []
  }
};

export const LOGGER_CONFIG = {
  serverLoggingUrl: '/gateway/logs',
  level: NgxLoggerLevel.WARN,
  serverLogLevel: NgxLoggerLevel.ERROR,
  enableSourceMaps: true
};

export const DATE_FORMAT = 'MMM D, YYYY - HH:mm';

export function changeConfig(configData: any): void {
  TENANT_CONFIG = configData;
}
export function addConfig(tag: string, content: any): void {
  TENANT_CONFIG[tag] = content;
}

export const AUTH_CONFIG = {
  refreshing_time: 5000,
  token_lifespan: 60
};

export const TIMEOUTS_CONFIG = {
  render_delay: 400,
  refreshing_time: '7s',
  warn_timeout: 5000,
  error_timeout: 10000,
  snackbar_duration: 1500,
  snackbar_error_duration: 3000,
  es_reindex_duration: 2000
};
